import MsgManagerVue from '@/views/sm/msg-manager/msg-manager.vue';

const basePath = '/sm/msg-manager';
const role = 'sm'; // 角色身份

export const SM_MSG_MANAGER_INDEX = 'sm-msg-manager-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MsgManagerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_MSG_MANAGER_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/msg-manager/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
